import React from 'react'

import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  PinterestIcon,
  EmailIcon,
} from 'react-share'

interface Props {
  subject?: string
  url: string
  text: string
  onClose: () => any // tslint:disable-line:no-any
}

const SocialShareLayer = ({ url, text, subject, onClose }: Props) => {
  return (
    <Dialog open onClose={onClose}>
      <DialogContent>
        <Grid container justify="center" alignItems="center" spacing={3}>
          <Grid item>
            <FacebookShareButton url={url} quote={text}>
              <FacebookIcon round />
            </FacebookShareButton>
          </Grid>
          <Grid item>
            <TwitterShareButton url={url} title={text}>
              <TwitterIcon round />
            </TwitterShareButton>
          </Grid>
          <Grid item>
            <WhatsappShareButton url={url} title={text}>
              <WhatsappIcon round />
            </WhatsappShareButton>
          </Grid>
          <Grid item>
            <PinterestShareButton url={url} media={url} description={text}>
              <PinterestIcon round />
            </PinterestShareButton>
          </Grid>
          <Grid item>
            <EmailShareButton subject={subject} body={text} url={url}>
              <EmailIcon round />
            </EmailShareButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default SocialShareLayer
try {
    // @ts-ignore
    SocialShareLayer.displayName = "SocialShareLayer";
    // @ts-ignore
    SocialShareLayer.__docgenInfo = { "description": "", "displayName": "SocialShareLayer", "props": { "subject": { "defaultValue": null, "description": "", "name": "subject", "required": false, "type": { "name": "string" } }, "url": { "defaultValue": null, "description": "", "name": "url", "required": true, "type": { "name": "string" } }, "text": { "defaultValue": null, "description": "", "name": "text", "required": true, "type": { "name": "string" } }, "onClose": { "defaultValue": null, "description": "", "name": "onClose", "required": true, "type": { "name": "() => any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/SocialShareLayer/SocialShareLayer.tsx#SocialShareLayer"] = { docgenInfo: SocialShareLayer.__docgenInfo, name: "SocialShareLayer", path: "src/components/SocialShareLayer/SocialShareLayer.tsx#SocialShareLayer" };
}
catch (__react_docgen_typescript_loader_error) { }